import { getTodayLocalDateString } from "../../utils";

import type { LaneFormState } from "../../utils";

export const generateDefaultLaneName = (): string =>
  `My Lane ${getTodayLocalDateString()}`;

const isCatchAll = (item: LaneFormState): boolean =>
  !item.equipmentTypes.length &&
  !item.services.length &&
  !item.originProvinces.length &&
  !item.destinationProvinces.length;

export const deduplicateCatchAllLanes = (
  items: LaneFormState[],
): LaneFormState[] => {
  const catchAllExpiriesSeen = new Set<string>();
  return items.filter((item) => {
    if (!isCatchAll(item)) return true;
    // Two catch-all lanes that stop matching on different days are different lanes,
    // so the expiry is part of what makes a catch-all a repeat of another.
    const expiry = item.hasExpiry ? item.expiresOn : "";
    if (catchAllExpiriesSeen.has(expiry)) return false;
    catchAllExpiriesSeen.add(expiry);
    return true;
  });
};
